export default __webpack_public_path__ + "static/media/966H.49bda2e6.jpg";